/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1TagId200,
  GetApiV1TagId401,
  GetApiV1TagId404,
  GetApiV1TagId500,
  GetApiV1TagIdPathParams,
  GetApiV1TagIdQueryParams,
  GetApiV1TagIdQueryResponse,
} from "../../types/tagRegistroController/GetApiV1TagId.ts";
import { tagViewModelSchema } from "../tagViewModelSchema.ts";

export const getApiV1TagIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1TagIdPathParams>;

export const getApiV1TagIdQueryParamsSchema = z
  .object({
    culture: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1TagIdQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1TagId200Schema = z.lazy(
  () => tagViewModelSchema,
) as unknown as ToZod<GetApiV1TagId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1TagId401Schema =
  z.any() as unknown as ToZod<GetApiV1TagId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1TagId404Schema =
  z.any() as unknown as ToZod<GetApiV1TagId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1TagId500Schema =
  z.any() as unknown as ToZod<GetApiV1TagId500>;

export const getApiV1TagIdQueryResponseSchema = z.lazy(
  () => getApiV1TagId200Schema,
) as unknown as ToZod<GetApiV1TagIdQueryResponse>;
